<template>
  <apexchart
    type="line"
    :height="height"
    :options="chartOptions"
    :series="series"
  />
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
import moment from 'moment'
export default {
  name: 'LineChart',
  components: {
    apexchart: VueApexCharts
  },
  props: {
    chartData: {
      type: Object,
      default: () => {}
    },
    height: {
      type: String,
      default: '500'
    }
  },
  computed: {
    series() {
      const serie1 = {
        name: 'Candidates'
      }

      const serie2 = {
        name: 'Recruiters'
      }

      let data = this.chartData
      serie1.data = data.lastWeekCandidates.reverse()
      serie2.data = data.lastWeekRecruiters.reverse()
      return [serie2]
    },

    dateRange() {
      const days = []
      const dateStart = moment()
      const dateEnd = moment().subtract(6, 'days')

      while (dateEnd.diff(dateStart, 'days') <= 0) {
        days.push(dateStart.format('DD/MM/YYYY'))
        dateStart.subtract(1, 'days')
      }

      return days.reverse()
    },

    chartOptions() {
      let chartOptions = {
        labels: this.dateRange,
        title: {
          text: 'Last 7 days',
          align: 'center',
          style: {
            fontSize: '21px'
          }
        },
        colors: ['#fec424', '#f4516c'],
        markers: {
          size: 5,
          hover: {
            size: 10
          }
        },
        chart: {
          toolbar: {
            show: false
          }
        }
      }
      return chartOptions
    }
  }
}
</script>
